export default __webpack_public_path__ + "static/media/yb-white.04dd4c6a.svg";